import {
    GET_LIST_TESTIMONIAL,
    ADD_ITEM_TESTIMONIAL,
    DELETE_ITEM_TESTIMONIAL,
    UPDATE_ITEM_TESTIMONIAL
} from '../actions/TestimonialsActions'

const initialState = {
    list: []  
}

const TestimonialsReducer = function (state = initialState, action) {    
    console.log("action", action);
    switch (action.type) {
        case GET_LIST_TESTIMONIAL: {            
            return {
                ...state,
                list: [...action.payload],
            }
        }   
        case ADD_ITEM_TESTIMONIAL: {                  
            state.list.push(action.payload);            
            return {
                ...state                
            }            
        }  
        case DELETE_ITEM_TESTIMONIAL: {
            const index = state.list.findIndex((item) => {
                return item.id == action.id
            })
            if(index >= 0){
                state.list.splice(index, 1);
            }  
            return {
                ...state                
            }            
        }       
        case UPDATE_ITEM_TESTIMONIAL: {
            const index = state.list.findIndex((item) => {
                return item.id == action.id
            })
            console.log("indexe", index)
            console.log("before splice", state.list)
            if(index >= 0){
                state.list.splice(index, 1);
            }  
            console.log("after splice", state.list)
            state.list.push(action.payload); 
            console.log("after push", state.list)
            return {
                ...state                
            }            
        }        
        default: {
            return {
                ...state,
            }
        }
    }
}

export default TestimonialsReducer
